import _objectSpread from "/home/deploy/dash/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import { getGlobalSingleton, SyncPromise, logger, isThenable } from '@sentry/utils';
/**
 * Returns the global event processors.
 */

function getGlobalEventProcessors() {
  return getGlobalSingleton('globalEventProcessors', function () {
    return [];
  });
}
/**
 * Add a EventProcessor to be kept globally.
 * @param callback EventProcessor to add
 */


function addGlobalEventProcessor(callback) {
  getGlobalEventProcessors().push(callback);
}
/**
 * Process an array of event processors, returning the processed event (or `null` if the event was dropped).
 */


function notifyEventProcessors(processors, event, hint) {
  var index = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
  return new SyncPromise(function (resolve, reject) {
    var processor = processors[index];

    if (event === null || typeof processor !== 'function') {
      resolve(event);
    } else {
      var result = processor(_objectSpread({}, event), hint);
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && processor.id && result === null && logger.log("Event processor \"".concat(processor.id, "\" dropped event"));

      if (isThenable(result)) {
        void result.then(function (final) {
          return notifyEventProcessors(processors, final, hint, index + 1).then(resolve);
        }).then(null, reject);
      } else {
        void notifyEventProcessors(processors, result, hint, index + 1).then(resolve).then(null, reject);
      }
    }
  });
}

export { addGlobalEventProcessor, getGlobalEventProcessors, notifyEventProcessors };